import 'vite/modulepreload-polyfill'

import on from 'dom-event'
import '@/js/lib/accessibility'
import init from '@/js/lib/init'
import { set, isIEorEdge } from '@/js/lib/util'
import { pushOnQuizLinksClick } from '@/js/lib/datalayer'
import '@/js/lib/global-events'
import '@/js/lib/timeline'
import '@/js/lib/custom'
import state from '@/js/lib/appState'

document.addEventListener('DOMContentLoaded', () => {
  if (isIEorEdge()) set(document.body, 'ie')
  if (window.SENTRY?.enabled) {
    Sentry.init({
      dsn: 'https://' + window.SENTRY.dsn
    })
  }
  init().mount()
  on(document.body, 'WheelBarrow.ReInitModules', (data) => {
    init('modules', data.detail).mount()
  })

  pushOnQuizLinksClick()

  const reploFullpageElement = document.getElementById('replo-fullpage-element')
  if (reploFullpageElement) {
    const buttons = reploFullpageElement.querySelectorAll('button')

    buttons.length > 0 && buttons.forEach((button) => {
      const spans = button.querySelectorAll('span[style]')

      spans.length > 0 && spans.forEach((span) => {
        if (span.style.display === 'contents') {
          span.style.removeProperty('display')

          if (span.getAttribute('style')?.trim() === '') {
            span.removeAttribute('style')
          }
        }
      })
    })

    const errorImages = reploFullpageElement.querySelectorAll('[alt="{{ reploProductImage.alt }}"]');
    if (errorImages.length > 0) {
      const depsProducts = document.getElementById("replo-deps-products");
      const jsonContent = depsProducts.textContent;
      const jsonData = JSON.parse(jsonContent);
      errorImages.forEach((image) => {
        const setEmptyAlt = () => image.setAttribute("alt", "");
        if (!Array.isArray(jsonData) || jsonData.length === 0) return setEmptyAlt()
        const productHandle = image.closest("[data-replo-product-handle]")?.getAttribute("data-replo-product-handle");
        if (!productHandle) return setEmptyAlt()
        const product = jsonData.find((product) => product.handle === productHandle);
        if (!product) return setEmptyAlt()
        const imageSrc = image.getAttribute("src");
        const productImage = product.data?.media?.find((media) => media.src.split("//")[1] === imageSrc.split("//")[1]);
        if (!productImage) return setEmptyAlt()
        const alt = productImage.alt;
        image.setAttribute("alt", alt || "");
      });
    }

    const setupListItems = (element) => {
      if (!element) return;
      element.setAttribute("role", "list");
      const children = element.children;
      if (children.length > 0) {
        Array.from(children).forEach((child, index) => {
          child.setAttribute("role", "listitem");
          child.setAttribute("aria-label", `Item ${index + 1} of ${children.length}`);
        });
      }
    };

    const addScreenReaderCarousel = (selector) => {
      const el = document.querySelector(`[data-rid="${selector}"]`);
      if (!el) return;

      el.setAttribute('aria-label', 'Testimonial Carousel');
      el.insertAdjacentHTML('afterbegin', `
        <div class="sr-only">
          Carousel section containing customer testimonials. Use the left and right arrows or swipe to navigate between testimonials.
        </div>
      `);
    }

    const testimonialCarouselEls = window.accessibilitySettings?.testimonialAccessibilityRidList
      ? window.accessibilitySettings.testimonialAccessibilityRidList.split(",").map(item => item.trim())
      : [];

    testimonialCarouselEls.push('acec259e-0ed5-403e-86b1-bc7dd7ac7cca', 'cebd0107-ebbf-48a0-b00f-479869fb23ce')
    if (testimonialCarouselEls.length) {
      testimonialCarouselEls.forEach(addScreenReaderCarousel);
    }

    const navContainer = document.querySelector('[data-rid="111e05d3-3813-4918-8dfb-a81f10a27777"]');

    navContainer && (() => {
      const ul = document.createElement('ul');
      ul.setAttribute('role', 'list');
      ul.className = 'r-1antzno';

      [...navContainer.children].forEach((dot, i) => {
        dot.setAttribute('role', 'button');
        dot.setAttribute('tabindex', '0');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);

        const li = document.createElement('li');
        li.appendChild(dot);
        ul.appendChild(li);
      });

      navContainer.replaceWith(ul);
    })();

    function replaceAlchemySpansInOpenModals() {
      const openModals = document.querySelectorAll('.ReactModal__Overlay--after-open');
      if (openModals.length > 0) {
        openModals.forEach(modal => {
          const spans = modal.querySelectorAll('.alchemy-rte span');
          spans.forEach(span => {
            const h2 = document.createElement('h2');
            h2.textContent = span.textContent;
            h2.style.cssText = span.style.cssText;
            span.parentNode.replaceChild(h2, span);
          });
        });
      }
    }

    function replaceAlchemySpansInProductSection () {
      const accordionEls = document.querySelectorAll('[data-rid="b837d6f1-e506-4e57-96dc-9143cb1fd372"], [data-rid="38af3fe5-256f-442f-ab18-b2d3b5dd2799"]');
      if (accordionEls) {
        accordionEls.forEach(el => {
          const h3 = el.querySelector('h3');
          const span = el.querySelector('span');
          if (h3) {
            const button = document.createElement('button');
            button.className = h3.className;
            button.innerHTML = h3.innerHTML;

            h3.parentNode.replaceChild(button, h3);
          }
          if (span) {
            const h2 = document.createElement('h2');
            h2.className = span.className;
            h2.innerHTML = span.innerHTML;
            span.parentNode.replaceChild(h2, span);
          }
        });
      }
    }

    function updateCarouselAccessibility(carousels) {
      carousels.forEach((carouselEl) => {
        const sliders = carouselEl.querySelectorAll('[data-replo-part="slides"], [data-replo-part="slide-track"]');
        const thumbs = carouselEl.querySelectorAll('[data-rid="891ee6c3-d74b-4117-a85b-2ab4ef2c18d2"]');

        sliders.length > 0 && sliders.forEach((slider) => {
          slider.removeAttribute("role");
          slider.removeAttribute("aria-label");
          const slides = slider.querySelectorAll("[data-replo-part=slide]");
          slides.forEach((slide, index) => {
            const ariaLabel = slide.getAttribute("aria-label");
            if (ariaLabel && ariaLabel.startsWith("Slide ")) {
              slide.setAttribute("aria-label", `Slide ${index + 1} of ${slides.length}`);
            }
          });
        });

        thumbs.length > 0 && thumbs.forEach((thumb, index) => {
          const ariaLabel = thumb.getAttribute("aria-label");
          if (ariaLabel && ariaLabel.startsWith("Go to ")) {
            thumb.setAttribute("aria-label", `Image ${index + 1} of ${thumbs.length}`);
          }
        });
      })
    }

    function updateSlideAccessibility(slide) {
      const isActive = slide.dataset.isActive;
      const container = slide.closest('[data-replo-product-handle]');

      if (container) {
        if (isActive !== 'true') {
          slide.setAttribute('aria-hidden', 'true');
          if (!slide.hasAttribute('data-orientation')) {
            slide.setAttribute('tabindex', '-1');
            slide.setAttribute('aria-hidden', 'true');
          }
        } else {
          slide.removeAttribute('aria-hidden');
          if (!slide.hasAttribute('data-orientation')) {
            slide.setAttribute('tabindex', '0');
            slide.setAttribute('aria-hidden', 'false');
          }
        }
      } else {
        if (isActive !== 'true') {
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
          const list = slide.querySelectorAll('[tabindex="0"]');
          list?.forEach(el => {
            el.classList.add('slide-invisible')
            el.setAttribute('tabindex', '-1')
          });
        } else {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('tabindex');
          const list = slide.querySelectorAll('[tabindex="-1"]');
          list?.forEach(el => {
            el.classList.contains('slide-invisible') && el.setAttribute('tabindex', '0')
          });
        }
      }
    }

    function updateSlidesAccessibility(slides) {
      slides.forEach(updateSlideAccessibility);
    }

    function replaceAriaCurrent(ariaCurrentEls) {
      ariaCurrentEls.forEach((ariaCurrentEl) => {

        ariaCurrentEl.removeAttribute("aria-selected");
      })
    }

    const debouncedUpdateSlides = debounce(() => {
      const carousels = document.querySelectorAll('[data-replo-carousel="true"]');
      const slides = document.querySelectorAll('[data-replo-part="slide"]');
      const ariaCurrentEls = document.querySelectorAll('[aria-current]');
      if (slides.length > 0) {
        updateSlidesAccessibility(slides);
      }
      if (ariaCurrentEls.length > 0) {
        replaceAriaCurrent(ariaCurrentEls);
      }

      if (carousels.length > 0) {
        updateCarouselAccessibility(carousels);
      }
    }, 100);

    function handleAttributeSlide(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' || mutation.type === 'childList') {
          debouncedUpdateSlides();
          break;
        }
      }
    }

    function debounce(fn, delay) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }

    const slides = document.querySelectorAll('[data-replo-part="slide"]');
    if (slides.length > 0) {
      updateSlidesAccessibility(slides);
    }


    applyAriaListRoles('[data-rid="f27b907f-b706-48c5-989e-4387e49e8b4c"]');
    applyAriaListRoles('[data-rid="96945f99-cbeb-4b5c-8de6-e68c94665e31"]');

    function applyAriaListRoles(containerSelector) {
      const container = document.querySelector(containerSelector);
      if (!container) return;

      const dots = container.querySelectorAll('[role="button"][tabindex]');
      if (!dots.length) return;

      container.setAttribute('role', 'list');
      dots.forEach(dot => {
        dot.setAttribute('role', 'listitem');
      });
    }

    function handleReviewStars() {
      const reviewStarEls = reploFullpageElement.querySelectorAll('.yotpo-sr-bottom-line-summary');
      if (reviewStarEls.length > 0) {
        reviewStarEls.forEach(el => {
          const href = el.getAttribute('href');
          if (!href) {
            el.setAttribute('href', '#yotpo-app');
          }
        });
      }
    }

    function handleSvgAccessibility() {
      if (!window.accessibilitySettings || !reploFullpageElement) return;

      let svgAccessibilityRidList = window.accessibilitySettings.svgAccessibilityRidList;

      if (!Array.isArray(svgAccessibilityRidList)) {
        svgAccessibilityRidList = (svgAccessibilityRidList || '').split(',').filter(Boolean);
      }

      svgAccessibilityRidList.push('8e448d6d-393c-46b6-b734-d700070a1f79', '22e2752a-819d-4e1b-a187-cd895540efc0');

      svgAccessibilityRidList.forEach(rid => {
        const el = reploFullpageElement.querySelector(`[data-rid="${rid}"]`);
        if (el) {
          const svgs = el.querySelectorAll('svg');
          svgs.forEach(svgEl => {
            svgEl.setAttribute('aria-hidden', 'true');
          });
        }
      });
    }

    function handleRoleAccessibility () {
      const roleEls = document.querySelectorAll('[data-rid="f6b8b660-0c36-4972-80d5-fd5f3a542705"]')
      if (!roleEls.length) return
      roleEls[0].setAttribute('aria-current', 'true');
      roleEls.forEach(role => {
        role.removeAttribute('role')

        if (role.getAttribute('aria-selected') === 'true') {
          role.setAttribute('aria-current', 'true');
        }
        if (role.getAttribute('aria-selected') === 'false') {
          role.setAttribute('aria-current', 'false');
        }
      })
    }

    function handleAnnouncementAccessibility() {
      let announcementAccessibilityRidList = window.accessibilitySettings?.announcementAccessibilityRidList
      ? window.accessibilitySettings.testimonialAccessibilityRidList.split(",").map(item => item.trim())
      : [];
      announcementAccessibilityRidList.push('acec259e-0ed5-403e-86b1-bc7dd7ac7cca', 'cebd0107-ebbf-48a0-b00f-479869fb23ce')
      if (announcementAccessibilityRidList.length > 0) {
        announcementAccessibilityRidList.forEach(rid => {
          const el = reploFullpageElement.querySelector(`[data-rid="${rid}"]`);
          if (el) {
            el.setAttribute('role', 'region');
            el.setAttribute('aria-label', 'announcement');
            el.removeAttribute('aria-labelledby');
          }
        });
      }
    }

    function handleSlideNavDotList() {
      let slideNavDotListRid = window.accessibilitySettings.slideNavDotListRid;
      slideNavDotListRid.push('bc91800e-97ee-4b92-bdfe-70f69f3d1c30', '37744f0d-4674-4e9d-9b01-675d74a95b84', 'fdc15fe0-b109-40f1-b8d1-ee192cd53cee');
      if (slideNavDotListRid) {
        slideNavDotListRid.forEach((rid) => {
          const ridElement = reploFullpageElement.querySelector(`[data-rid="${rid}"]`);
          if (ridElement) {
            setupListItems(ridElement);
          }
        });
      }
    }

    handleSlideNavDotList()

    function updateColorContrast() {
      const colorContrastRidList = window.accessibilitySettings.colorContrastRidList;
      if (!Array.isArray(colorContrastRidList)) return;
      colorContrastRidList.forEach((x) => {
        const data = x.split(":");
        const rid = data[0];
        const type = data[1];
        const value = data[2];
        const ridElement = reploFullpageElement.querySelector(`[data-rid="${rid}"]`);
        if (!ridElement || !type || !value) return;
        ridElement.style[type] = value;
      });
    }

    updateColorContrast();

    function UpdateMiniCart () {
      const iconCartAccessibilityRidList = window.accessibilitySettings?.iconCartAccessibilityRidList
      if (iconCartAccessibilityRidList) {
        iconCartAccessibilityRidList.split(',').forEach(rid => {
          const cartIcons = document.querySelectorAll(`[data-rid="${rid}"]`)

          cartIcons.forEach(icon => {
            icon.addEventListener('click', function (e) {
              e.preventDefault()

              state.isMiniCartOpen = true
            })
          })
        })
      }
    }

    function removeTabindexCarousel() {
      const videoCarouselAccessibilityRidList = window.accessibilitySettings.videoCarouselAccessibilityRidList || '59e7c949-6e07-4f3e-ad47-d965cf1912ec';
      const target = document.querySelector(`[data-rid="${videoCarouselAccessibilityRidList}"]`);
      if (!target) return;

      const firstChildEl = target?.firstElementChild
      firstChildEl?.removeAttribute('tabindex');

      setTimeout(() => {
        const sliderEls = firstChildEl?.querySelectorAll('[data-replo-part="slide"]');

        if (sliderEls?.length > 0) {
          sliderEls.forEach(sliderEl => {
            const buttonEls = sliderEl.querySelectorAll('[role="button"]');

            if (buttonEls.length > 0) {
              buttonEls.forEach(buttonEl => {
                buttonEl.setAttribute('tabindex', '0');
              })
            }
            sliderEl.removeAttribute('aria-hidden');
            sliderEl.removeAttribute('tabindex');
          })
        }
      }, 100)
    }

    function updateHeaderTag() {
      const headerAccessibilityRidList = window.accessibilitySettings?.headerAccessibilityRidList
      const oldHeader = document.querySelector(`[data-rid="${headerAccessibilityRidList}"]`);
      if (oldHeader) {
        const newHeader = document.createElement("header");
        newHeader.style.setProperty("display", "block", "important");

        for (let attr of oldHeader.attributes) {
          if (attr.name !== "role") {
            newHeader.setAttribute(attr.name, attr.value);
          }
        }

        newHeader.append(...oldHeader.childNodes);
        oldHeader.replaceWith(newHeader);
      }
    }

    updateHeaderTag()

    function swapElements() {
      const el1 = document.querySelector('[data-rid="ebd315cb-cd2b-4b7c-8d97-cb0e7cd798d2"]');
      const el2 = document.querySelector('[data-rid="f27b907f-b706-48c5-989e-4387e49e8b4c"]');

      if (!el1 || !el2) return false;
      const parent = el1.parentNode;
      const currentOrder = Array.from(parent.children);
      const el1Index = currentOrder.indexOf(el1);
      const el2Index = currentOrder.indexOf(el2);
      if (el1Index > el2Index) return true;

      const sibling1 = el1.nextSibling === el2 ? el1 : el1.nextSibling;
      el2.parentNode.insertBefore(el1, el2);
      parent.insertBefore(el2, sibling1);
      el2.style.order = '1';

      return true;
    }

    let swapped = swapElements();

    const observer = new MutationObserver((mutationsList) => {
      replaceAlchemySpansInOpenModals();
      handleAttributeSlide(mutationsList);
      handleReviewStars();
      handleSvgAccessibility();
      handleAnnouncementAccessibility();
      handleRoleAccessibility()
      UpdateMiniCart()
      updateColorContrast();
      replaceAlchemySpansInProductSection()
      removeTabindexCarousel();
      replaceAlchemySpansInProductSection()
      if (!swapped) {
        swapped = swapElements();
        if (swapped) {
          observer.disconnect();
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-is-target'] });

    function enhanceTestimonialAccessibility() {
      let ridList = window.accessibilitySettings?.testimonialAccessibilityRidList
        ? window.accessibilitySettings.testimonialAccessibilityRidList.split(",").map(item => item.trim())
        : [];
        ridList.push('acec259e-0ed5-403e-86b1-bc7dd7ac7cca', 'cebd0107-ebbf-48a0-b00f-479869fb23ce')
      if (!ridList.length) return
      ridList.forEach((rid) => {
        const slide = document.querySelector(`[data-rid="${rid}"]`);

        if (slide) {
          const quoteParagraphs = slide.querySelectorAll('.alchemy-rte:nth-of-type(2) p');

          quoteParagraphs.forEach((p) => {
            if (!p.closest('blockquote')) {
              const blockquote = document.createElement('blockquote');
              blockquote.innerHTML = p.innerHTML;
              p.parentNode.replaceChild(blockquote, p);
            }
          });
        }
      });
    }

    enhanceTestimonialAccessibility();
  }
})

document.addEventListener('octane.quiz.completed', () => {
  const resultitemEls = document.querySelectorAll('[data-element="oct-quiz-resultitem"]')
  if (!resultitemEls.length) return

  resultitemEls.forEach(item =>
    item.querySelectorAll('a[tabindex="-1"]').forEach(link =>
      link.removeAttribute('tabindex')
    )
  )
}, false)
